import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/img/logo.png";
const Footer = () => {
	const handleSubmit = (e) => {
		e.preventDefault();
	};
	return (
		<footer className="bg-gradient">
			<div className="container">
				<div className="footer-wrapper">
					<div className="footer-widget logo-area">
						<Link to="/" className="footer-logo">
							<img src={logo} alt="" />
						</Link>
						<p>
						Solrocket - Alpha Launchpad on Solana

						</p>
						<ul className="social">
							{social?.map(({ icon, url }, i) => (
								<li key={i}>
									<Link to={url}>
										<img src={icon} alt="" width={20} />
									</Link>
								</li>
							))}
						</ul>
					</div>
					{data?.map(({ title, links }, i) => (
						<div className="footer-widget widget-link" key={i}>
							{title && <h6 className="title">{title}</h6>}
							<ul className="links">
								{links?.map(({ name, url }, j) => (
									<li key={j}>
										<a href={`mailto:${name}`}>{name}</a>

									</li>
								))}
							</ul>
						</div>
					))}
					{/* <div className="footer-widget newsletter-widget">
						<h6 className="title">Subscribe to Newsletter</h6>
						<form onSubmit={handleSubmit} className="subscribe-form">
							<input
								type="text"
								className="form-control"
								placeholder="Email Id"
							/>
							<button type="submit" className="cmn-btn">
								Subscribe
							</button>
						</form>
					</div> */}
				</div>
			</div>
		</footer>
	);
};
const social = [
	{
		icon: "/social/twitter2.png",
		url: "https://x.com/solrocketpad",
	},
	{
		icon: "/social/telegram.png",
		url: "https://t.me/SolrocketChannel",
	},
	{
		icon: "/social/telegram.png",
		url: "https://t.me/SolrocketChat",
	},
	// {
	// 	icon: "/social/instagram.png",
	// 	url: "#",
	// },
	// {
	// 	icon: "/social/discord.png",
	// 	url: "#",
	// },
	{
		icon: "/social/github.png",
		url: "https://github.com/solrocket",
	},
	{
		icon: "/social/medium.png",
		url: "https://medium.com/@solrocket",
	},
	{
		icon: "/social/www.png",
		url: "https://www.solrocket.io/",
	},
];
const data = [

	{
		title: "Contact Us",
		links: [
			{ name: "mail@solrocket.io", url: "#" },

		],
	},
];
export default Footer;
